import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdam',
  templateUrl: './pdam.component.html',
  styleUrls: ['./pdam.component.css']
})
export class PdamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
